/**
 * components/branding/ClientBrandingFooter.tsx
 *
 * Persistent attribution line at the bottom of the client form pages.
 * Shows "Questionnaire envoyé par [displayName]" in a discreet style.
 * Only rendered when a displayName is available.
 *
 * Created Apr 2026: part of the continuous branding refactor for the
 *   client-facing form experience.
 */

interface ClientBrandingFooterProps {
  displayName: string | null;
}

export default function ClientBrandingFooter({ displayName }: ClientBrandingFooterProps) {
  if (!displayName) return null;

  return (
    <div className="flex-shrink-0 flex items-center justify-center py-3 px-4">
      <p className="text-xs text-neutral-400">
        Questionnaire envoyé par{' '}
        <span className="font-medium text-neutral-500">{displayName}</span>
      </p>
    </div>
  );
}
